import { createContext } from "react";
import { Token } from "types/models";

interface SessionContextType {
  sessionData: Token | null;
  setSessionData: (data: Token | null) => void;
}

// Context related to connection details
export default createContext<SessionContextType>({
  sessionData: null,
  setSessionData: (_data) => {},
});
